// extracted by mini-css-extract-plugin
export default {"modalContent":"style_modalContent__bHK7D","modalBody":"style_modalBody__MsgDu","modalFooter":"style_modalFooter__1M9fJ"};